import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Form, Field, reduxForm, formValueSelector, change } from 'redux-form/immutable';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import MenuItem from '@material-ui/core/MenuItem';
import { fromJS, List } from 'immutable';

import _ from 'lodash';
import { renderSelect, renderSlider } from '../../../utils/reduxforms';

import ReduxDialog from '../../Common/ReduxDialog/index';
import { showDialog, hideDialog, showError } from '../../../redux/actions/dialogs';
import { generatePdfLabels, generateZebraLabels } from '../../../utils/labels';
import { fetchLabelFormatsRoutine, fetchPrintersRoutine } from '../../../redux/routines';
import { sortByLocation, toJS } from '../../../utils/helper';

import styles from './styles';
import {
  GENERATE_LABELS_DIALOG,
  LOADING_DIALOG
} from '../../../redux/constants/dialogs';
import { getDialogContextValue } from '../../../redux/selectors';
import MenuButton from '../../Common/MenuButton';
import { required } from '../../../utils/formvalidation';

const printZebra = (job, tasks, labelFormat, printer, options) => {
  return generateZebraLabels(job, tasks, labelFormat, options)
    .then((labels) => {
      console.log('labels', labels);
      if (printer.connection === 'network' || printer.connection === 'usb') {
        const mapForm = document.createElement('form');
        mapForm.target = 'Map';
        mapForm.method = 'POST'; // or "post" if appropriate

        if (printer.connection === 'network') {
          mapForm.action = 'http://printing.staza.io/zebraprint.php';
        } else {
          mapForm.action = 'http://printing.staza.io/zebrausbprint.php'; // 'http://printing.staza.io/zebrausbprint.php';
        }

        const BATCH_SIZE = 100000000;
        const batches = labels.length / BATCH_SIZE;
        _.range(0, batches).forEach((i) => {
          console.log('adding batch', i);
          const mapInput = document.createElement('input');
          mapInput.type = 'text';
          mapInput.name = `specification`; // ${i}
          mapInput.value = labels.slice(i * BATCH_SIZE, (i + 1) * BATCH_SIZE).join('');
          mapForm.appendChild(mapInput);
        });

        document.body.appendChild(mapForm);

        const map = window.open('', 'Map', 'status=0,title=0,height=400,width=600,scrollbars=0');

        if (map) {
          return mapForm.submit();
        } else {
          throw new Error('You must allow popups for this map to work.');
        }
      } else {
        throw new Error(`Unknown printer connection type - ${printer.connection}`);
      }
    });
};

const createExampleTask = () => {
  return {
    id: '12345',
    contact: {
      name: 'Mary Smith'
    },
    origin: {
      building: 'Mount Everest',
      floor: 'Base Camp',
      space: 'A1',
    },
    destination: {
      building: 'Mount Everest',
      floor: 'Peak',
      space: 'A2',
    },
    items: [{
      id: '0005',
      icon: 'fan',
      name: 'Fan',
      zplImage: '^GFA,1300,1300,13,,:::Q07FE,P0KF,O07KFE,N03MFC,N0IF801IF,M03FFK0FFC,M07F8K01FE,L01FEM07F8,L03F8M01FC,L07FO0FE,L0FC01FCK03F,K01F807FF8J01F8,K03F01IFCK0FC,K07C03JFK03E,K0F803F07F8J01F,J01F807C00F8J01F8,J01F0078007CK0F8,J03E00FI03CK07C,J07C00FI03EK03E,J07C00FI01EK03E,J0F800FI01EK01F,J0FI0FJ0FL0F,I01FI0F8I0FL0F8,I01EI078I0FL078,I01EI07EI0FL078,I03CI03FI0FL03C,I03CI01F800FL03C,I07CJ0FE00FL03E,I078J07F00FL01E,I078J01F81FL01E,I078K0FCFEI0F001E,I078K07FFE007FE01E,I0F8K03IF01IF01F,I0FL01IF87IF80F,I0FL01F0JF0FC0F,I0FL03E07FFC07E0F,I0FL03C03FF001E0F,I0FL0FC03F8001E0F,I0FK07FC03CI01F0F,I0FJ01FFC03CJ0F0F,I0FJ03FFE07CJ0F0F,I0FJ07F1F0F8I01F0F,I0FJ0FC1IF8I01E0F,I0F8001F80IFJ03E1F,I078003E007FFCI03E1E,I078007C003FFEI07C1E,I078007C007C3F800F81E,I07800F800781FE03F81E,I07C00FI0780KF03E,I03C00FI0F803IFC03C,I03C00FI0FI0IF803C,I03E00FI0FI01FE007C,I01E00FI0FN078,I01F00FI0FN0F8,J0F00FI0FN0F,J0F80F800FM01F,J07C07800FM03E,J07C07C01FM03E,J03E07E03EM07C,J01F03F07EM0F8,J01F81IFCL01F8,K0F80IF8L01F,K07C07FFM03E,K03F01F8M0FC,K01F8O01F8,L0FCO03F,L07EO07E,L03F8M01FC,L01FEM07F8,M07F8K01FE,M03FFK0FFC,N0IFI0IF,N03MFC,O07KFE,O01KF8,P03IFC,P03C03C,P07C03E,P07801E,P0F801F,O01F801F8,O03FI0FC,N01FEI07F8,N0FFCI03FF,M07FF8I01FFE,M0FFEK07FF,L01FFM0FF8,L01FO0F8,L03EO07C,L03CO03C,::L03QFC,::L01QF8,',
    }],
  };
};

const createBlankTask = () => {
  return { id: 'blank' };
};

const sortTasksByLocation = (tasks) => tasks ? tasks.sort((a, b) => sortByLocation(a.origin, b.origin)) : null;

const handleGenerate = (job, { labelFormat, printer, options, type, tasks }, showDialog) => {
  console.log('handleGenerate', labelFormat.type);
  if (labelFormat.type === 'zebra') {
    return printZebra(job, sortTasksByLocation(tasks), labelFormat, printer, options);
  } else {
    showDialog(LOADING_DIALOG);
    return generatePdfLabels(job, tasks, labelFormat, options);
  }
};

const handleGenerateTest = (job, values, showDialog) => {
  console.log('handleGenerateTest', values);
  values.tasks = values.tasks && values.tasks.length > 0 ? values.tasks.slice(0, 1) : [createExampleTask()];
  values.options.labels = 1;
  return handleGenerate(job, values, showDialog);
};

const handleGenerateBlanks = (job, values, showDialog) => {
  values.tasks = [createBlankTask()];
  return handleGenerate(job, values, showDialog);
};

class GenerateLabelsDialog extends React.Component {
  componentWillMount() {
    const { labelFormats, printers, fetchLabelFormats, fetchPrinters } = this.props;

    if (!labelFormats || labelFormats.length === 0) {
      fetchLabelFormats();
    }

    if (!printers || printers.length === 0) {
      fetchPrinters();
    }
  }

  componentWillReceiveProps({ labelFormat }) {
    if (labelFormat && (!this.props.labelFormat || this.props.labelFormat.id !== labelFormat.id)) {
      this.props.change('options.labels', labelFormat.type !== 'zebra' ? labelFormat.layout.columns * labelFormat.layout.rows : 8);
    }
  }

  // handleSelectLabelFormat = (labelFormat) => {
  //   // console.log('hand', event);
  //   // const labelFormat = this.props.labelFormats.find((lf) => lf.id === labelFormatId);
  //   console.log('handleSelectLabelFormat', labelFormat);
  //   this.setState({
  //     labelFormat,
  //     specification: labelFormat.specification,
  //     sheets: labelFormat.type === 'zebra' ? 8 : 1,
  //   });
  // };

  handleHideGenerateMenu = (value) => {
    console.log(value);
    this.setState({
      generateMenu: value,
    });
  };

  submit = (type) => {
    console.log('typetypetypetype', type);
    this.props.change('type', type);
    setTimeout(() => this.props.submit(), 500);
  };

  // handleCustomizeSpecification = () => {
  //   this.setState({
  //     customizeSpecification: true,
  //     specification: this.state.labelFormat.specification,
  //   });
  // };

  renderLabelFormat(labelFormat) {
    switch (labelFormat.type) {
      case 'zebra':
        return this.renderZebraLabelFormat(labelFormat);
      default:
        return this.renderStandardLabelFormat(labelFormat);
    }
  }

  renderZebraLabelFormat() {
    {/*{this.state.customizeSpecification ? <TextField*/
    }
    {/*value={this.state.specification}*/
    }
    {/*onChange={(evt, specification) => this.setState({ specification })}*/
    }
    {/*multiline*/
    }
    {/*rows={8}*/
    }
    {/*fullWidth/> : <Button variant="contained" onClick={this.handleCustomizeSpecification}>Customize*/
    }
    {/*Labels...</Button>}*/
    }

  }

  renderStandardLabelFormat(labelFormat) {
    const layout = labelFormat.layout;

    return (
      <div>
        <Paper style={styles.paper}>
          <table>
            <tbody>
            <tr>
              <td style={styles.header} width="60%">Rows</td>
              <td width="20%"></td>
              <td style={styles.layoutValue} width="20%">{layout.rows}</td>
            </tr>
            <tr>
              <td style={styles.header}>Columns</td>
              <td></td>
              <td style={styles.layoutValue}>{layout.columns}</td>
            </tr>
            <tr>
              <td style={styles.header}>Label Width</td>
              <td></td>
              <td style={styles.layoutValue}>{layout.label.width}</td>
            </tr>
            <tr>
              <td style={styles.header}>Label Height</td>
              <td></td>
              <td style={styles.layoutValue}>{layout.label.height}</td>
            </tr>
            <tr>
              <td style={styles.header}>Margins</td>
              <td>Top</td>
              <td style={styles.layoutValue}>{layout.sheet.margins.top.toFixed(2)}</td>
            </tr>
            <tr>
              <td></td>
              <td>Left</td>
              <td style={styles.layoutValue}>{layout.sheet.margins.left.toFixed(2)}</td>
            </tr>
            <tr>
              <td></td>
              <td>Right</td>
              <td style={styles.layoutValue}>{layout.sheet.margins.right.toFixed(2)}</td>
            </tr>
            <tr>
              <td></td>
              <td>Bottom</td>
              <td style={styles.layoutValue}>{layout.sheet.margins.bottom.toFixed(2)}</td>
            </tr>
            <tr>
              <td style={styles.header}>Internal Horizontal Spacing</td>
              <td></td>
              <td style={styles.layoutValue}>{layout.internal.horizontal.toFixed(2)}</td>
            </tr>
            <tr>
              <td style={styles.header}>Internal Vertical Spacing</td>
              <td></td>
              <td style={styles.layoutValue}>{layout.internal.vertical.toFixed(2)}</td>
            </tr>
            </tbody>
          </table>
        </Paper>
      </div>);
  }

  renderLabelImage(labelFormat) {
    return (
      <img
        src={`https://assets.staza.io/labelformats/labels_${labelFormat.key}.jpg`}
        height={300}
        alt={labelFormat.name}/>);
  }

  render() {
    const { printers, labelFormats, labelFormat, options, job, handleSubmit } = this.props;
    console.log('options, options', options);

    console.log('job.tasks', job.tasks);
    const taskCount = job && job.tasks && job.tasks.count ? job.tasks.count : 0;
    const count = labelFormat ? (taskCount * options.labels) : 0;
    console.log('count', count);
    console.log('labelFormat', labelFormat);

    let exceedingLimits = false;
    let printLabel = 'Generate';
    let blanksLabel = 'Print Blanks';

    if (labelFormat) {
      switch (labelFormat.type) {
        case 'zebra':
          printLabel = `Print (${count} Labels)`;
          blanksLabel = `Print Blanks (${options.labels} Labels)`;
          break;
        default:
          printLabel = `Generate (${count} Labels)`;
          blanksLabel = `Generate Blanks (${options.labels} Labels)`;
          // exceedingLimits = count > 100;
          break;
      }
    }

    const actions = [
      <Button
        key="close"
        variant="text"
        onClick={() => this.props.hideDialog(GENERATE_LABELS_DIALOG)}
      >Close</Button>,
      <MenuButton
        label="Generate"
        key="generate"
        color="primary"
      >
        <MenuItem
          value="test"
          onClick={() => this.submit('test')}
          disabled={exceedingLimits || !labelFormat}
        >Test Print</MenuItem>
        <MenuItem
          value="blanks"
          onClick={() => this.submit('blanks')}
          disabled={exceedingLimits || !labelFormat}
        >{blanksLabel}</MenuItem>
        <MenuItem
          value="print"
          onClick={() => this.submit('generate')}
          disabled={exceedingLimits || !labelFormat}
        >{printLabel}</MenuItem>
      </MenuButton>
    ];

    return (
      <ReduxDialog
        name={GENERATE_LABELS_DIALOG}
        title="Generate Labels"
        actions={actions}
        bodyStyle={styles.body}
        fullWidth
        maxWidth="sm"
      >
        <Form onSubmit={handleSubmit} style={styles.form}>
          {/*{exceedingLimits ?*/}
            {/*<Paper style={styles.exceedingLimits}><WarningIcon style={styles.warningIcon}/> You can only*/}
              {/*generate 50 sheets when choosing a conventional label type/printer option. Using a Zebra printer is not*/}
              {/*capped</Paper> : null}*/}

          <Grid container spacing={8}>
            <Grid item xs>
              <Grid container spacing={8}>
                <Grid item xs={12}>
                  <Field
                    label="Label Format"
                    name="labelFormat"
                    fullWidth
                    component={renderSelect}
                    validate={required}
                  >
                    {(labelFormats || new List()).map((format) => <MenuItem
                      key={format.get('id')}
                      value={format}>{format.get('name')}</MenuItem>)}
                  </Field>
                </Grid>

                {labelFormat && labelFormat.type === 'zebra' ? <Grid item xs={12}>
                  <Field
                    label="Printer"
                    name="printer"
                    fullWidth
                    component={renderSelect}
                    validate={required}
                  >
                    {(printers || new List()).map((printer) => <MenuItem
                      key={printer.get('id')}
                      value={printer}>{printer.get('name')}</MenuItem>)}
                  </Field>
                </Grid> : null}

                <Grid item xs={12}>
                  <Field
                    label="Labels Per Task"
                    name="options.labels"
                    component={renderSlider}
                    min={1}
                    max={50}
                    step={1}
                  />
                </Grid>

                {labelFormat ? (<Grid item xs={12}>{this.renderLabelFormat(labelFormat)}</Grid>) : null}

              </Grid>
            </Grid>

            <Grid item>
              {labelFormat ? this.renderLabelImage(labelFormat) : null}
            </Grid>
          </Grid>
        </Form>
      </ReduxDialog>
    );
  }
}

GenerateLabelsDialog.propTypes = {
  showDialog: PropTypes.func.isRequired,
  hideDialog: PropTypes.func.isRequired,
  showError: PropTypes.func.isRequired,

  fetchLabelFormats: PropTypes.func.isRequired,
  fetchPrinters: PropTypes.func.isRequired,
  labelFormats: PropTypes.object,
  printers: PropTypes.object,

  tasks: PropTypes.array,
  job: PropTypes.object.isRequired,
};

const form = reduxForm({
  form: GENERATE_LABELS_DIALOG,  // a unique identifier for this form
  // onSubmit: (values, dispatch, props) => {
  //   return dispatch(saveEmployeeRoutine.trigger(values));
  // },
  initialValues: fromJS({
    options: {
      labels: 8,
      embedType: true,
    }
  }),
  onSubmit: (values, dispatch, props) => {
    console.log('inSubmit', values.toJS());
    console.log('values.get(\'type\')', values.get('type'));
    console.log('props.showDialog', props.showDialog);
    switch (values.get('type')) {
      case 'test':
        return handleGenerateTest(props.job, values.toJS(), props.showDialog);
      case 'blanks':
        return handleGenerateBlanks(props.job, values.toJS(), props.showDialog);
      case 'generate':
        return handleGenerate(props.job, values.toJS(), props.showDialog);
      default:
        throw new Error('Invalid generate type');
    }
  },
  onSubmitSuccess: (result, dispatch, props) => {
    console.log('onSubmitSuccess');
    props.hideDialog(GENERATE_LABELS_DIALOG);
  },
  onSubmitFail: (errors, dispatch, submitError, props) => {
    props.showError({
      message: submitError.message,
    });
    hideDialog(LOADING_DIALOG);
  }
})(GenerateLabelsDialog);

function mapStateToProps(state) {
  const selector = formValueSelector(GENERATE_LABELS_DIALOG);

  const context = getDialogContextValue(state);
  return {
    job: toJS(context(GENERATE_LABELS_DIALOG, 'job')),
    tasks: toJS(context(GENERATE_LABELS_DIALOG, 'tasks')),

    labelFormats: state.getIn(['labelformats', 'labelFormats', 'data']),
    printers: state.getIn(['printers', 'printers', 'data']),

    labelFormat: toJS(selector(state, 'labelFormat')),
    options: toJS(selector(state, 'options')),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchLabelFormats: fetchLabelFormatsRoutine.trigger,
    fetchPrinters: fetchPrintersRoutine.trigger,

    change: (field, value) => change(GENERATE_LABELS_DIALOG, field, value),

    showDialog,
    hideDialog,
    showError,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(form);



// WEBPACK FOOTER //
// ./src/components/Jobs/GenerateLabelsDialog/index.js